import { render, staticRenderFns } from "./assign-resellers-list.vue?vue&type=template&id=025b50ed&"
import script from "./assign-resellers-list.vue?vue&type=script&lang=js&"
export * from "./assign-resellers-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports